// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\Entity.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { BEBaseElement } from './BEBaseElement';
import { Dependency } from '../../../../../com/MetaPattern/MDA/MD/APPModel/Dependency';
import { BEComponent } from './BEComponent';
/**
 * 导入名空间 实体类
 * 导入名空间
 */
export class BEImportNamespace extends BEBaseElement {
  /** 名字空间 : 要导入的名字空间 */
  private _namespace: string;

  /** 设置：名字空间 */
  public get namespace() {
    return this._namespace;
  }

  /** 获取：名字空间 */
  public set namespace(value: string) {
    this._namespace = value;
  }

  /** 依赖包 的ID */
  private _dependency_ID: string;

  /** 获取：依赖包 的ID */
  public get dependency_ID() {
    return this._dependency_ID;
  }

  /** 设置：依赖包 的ID */
  public set dependency_ID(value: string) {
    this._dependency_ID = value;
  }

  /** 依赖包  */
  private _dependency: Dependency;

  /** 获取：依赖包  */
  public get dependency() {
    return this._dependency;
  }

  /** 设置：依赖包  */
  public set dependency(value: Dependency) {
    this._dependency = value;
    if (value !== null) {
      this.dependency_ID = value.id;
    } else {
      this.dependency_ID = '';
    }
  }

  /** 组件 的ID */
  private _component_ID: string;

  /** 获取：组件 的ID */
  public get component_ID() {
    return this._component_ID;
  }

  /** 设置：组件 的ID */
  public set component_ID(value: string) {
    this._component_ID = value;
  }

  /** 组件  */
  private _component: BEComponent;

  /** 获取：组件  */
  public get component() {
    return this._component;
  }

  /** 设置：组件  */
  public set component(value: BEComponent) {
    this._component = value;
    if (value !== null) {
      this.component_ID = value.id;
    } else {
      this.component_ID = '';
    }
  }

  constructor() {
    super();
    this._namespace = '';
    this._dependency_ID = '';
    this._dependency = null;
    this._component_ID = '';
    this._component = null;
  }

  /**
   * 将对象进行所有属性值的复制
   * @param element 要复制的对象
   * @param hasReference 是否复制引用实体
   */
  public copyFrom(element: BEImportNamespace, hasReference: boolean): void {
    if (element != null) {
      super.copyFrom(element, hasReference);
      this.namespace = element.namespace;
      this.dependency_ID = element.dependency_ID;
      if (hasReference && element.dependency !== null) {
        this.dependency = element.dependency;
      }
      this.component_ID = element.component_ID;
      if (hasReference && element.component !== null) {
        this.component = element.component;
      }
    }
  }

  protected Deserialize(json: any): void {
    super.Deserialize(json);
    // Add self attribute
    this.namespace = json.Namespace;
    this.dependency_ID = json.Dependency_ID;
    // if (json.Dependency !== null) {
    //   this.dependency = Dependency.Create(json.Dependency);
    // }
    this.component_ID = json.Component_ID;
    // if (json.Component !== null) {
    //   this.component = BEComponent.Create(json.Component);
    // }
  }

  protected Serialize(json: any): void {
    super.Serialize(json);
    json.Namespace = this.namespace;
    json.Dependency_ID = this.dependency_ID;
    json.Component_ID = this.component_ID;
  }

  static Create(json: any): BEImportNamespace {
    const bEImportNamespace = new BEImportNamespace();
    bEImportNamespace.Deserialize(json);
    bEImportNamespace.json = json;
    return bEImportNamespace;
  }
}
